import { VideoContent } from './content';
import { ApiResponse } from './api';
import { BaseSearchParams } from './search';

export const CONTENT_TYPES = {
  LIVE: 'Live'
} as const;

export type LiveVideoProvider = 'youtube' | 'vimeo' | 'custom';

export type LiveBroadcastStatus = 'live' | 'upcoming' | 'completed';

export interface LiveSearchParams extends BaseSearchParams {
  broadcastStatus?: LiveBroadcastStatus;
}

export interface LiveVideoConfig {
  provider: LiveVideoProvider;
  enabled: boolean;
}

export interface GetCompletedVideosOptions extends Partial<BaseSearchParams> {
  broadcastStatus: 'completed';
}

export interface LiveVideoService {
  // Live streaming methods
  getLiveVideos(): Promise<VideoContent | null>;
  getCompletedVideos(options: GetCompletedVideosOptions): Promise<ApiResponse<VideoContent>>;
  
  // General live video methods
  searchLives(params: LiveSearchParams): Promise<ApiResponse<VideoContent>>;
  getLiveById(id: string): Promise<VideoContent>;
} 